export enum PaymentMethod {
  Google = 'Google Pay',
  Apple = 'Apple Pay',
  Card = 'Credit/Debit Card',
}
